import { progressAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
export { Progress, ProgressLabel } from "@chakra-ui/react";
const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);
export const ThemedProgress = defineMultiStyleConfig({
    baseStyle: {
        track: {
            borderRadius: 'rounded'
        },
        filledTrack: {
            bg: 'background.neutral.inverse.default',
            _groupHover: {
                bg: 'background.neutral.inverse.hovered'
            }
        }
    },
    sizes: {
        xs: {
            track: {
                height: '4px'
            }
        },
        sm: {
            track: {
                height: '4px'
            }
        },
        md: {
            track: {
                height: '4px'
            }
        },
        lg: {
            track: {
                height: '4px'
            }
        }
    },
    variants: {
        onPrimary: {
            track: {
                bg: 'background.neutral.secondary.default',
                _groupHover: {
                    bg: 'background.neutral.secondary.hovered'
                }
            }
        },
        onSecondary: {
            track: {
                bg: 'background.neutral.tertiary.default',
                _groupHover: {
                    bg: 'background.neutral.tertiary.hovered'
                }
            }
        },
        onTertiary: {
            track: {
                bg: 'background.neutral.secondary.default',
                _groupHover: {
                    bg: 'background.neutral.secondary.hovered'
                }
            }
        }
    },
    defaultProps: {
        variant: 'onPrimary',
        size: 'md'
    }
});

//# sourceMappingURL=Progress.js.map